module.exports = __webpack_public_path__ + "img/fsg_track.ce902e59.svg";